import { TeamChatUserStatus } from '@weave/schema-gen-ts/dist/schemas/team-chat/v1/api_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaTeamChatUserStatusV1Service = bindHTTP(TeamChatUserStatus);
export const serviceName = 'team-chat-user-status-v1' as const;
